import { SUPPLIER_CATEGORY_OPTIONS } from "@/api/suppliers.constraints";
import { Badge } from "@/components/ui/badge";
import type { SupplierSummary } from "@/types/supplier";

interface Props {
  supplier: SupplierSummary;
}

export const SupplierCategories = ({ supplier }: Props) => {
  const categories = SUPPLIER_CATEGORY_OPTIONS.filter(([field]) => supplier[field]);
  return (
    <div role="group" aria-label={`${supplier.name} categories`} className="mt-2 flex flex-wrap gap-1.5">
      {categories.length ? (
        categories.map(([field, label]) => (
          <Badge key={field} variant="outline">
            {label}
          </Badge>
        ))
      ) : (
        <span className="text-xs text-gray-500">No categories</span>
      )}
    </div>
  );
};
